export default __webpack_public_path__ + "static/media/non-household-3.ed7a5d4b.jpg";